var _path, _rect, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewTooltip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 34,
    viewBox: "0 0 73 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 0L32.5 6H40.5L36.5 0Z",
    fill: "#0D101A",
    fillOpacity: 0.8
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 73,
    height: 28,
    rx: 4,
    fill: "#0D101A",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.712 14.976H9.62V15.732H15.776C15.776 16.104 15.752 16.596 15.728 17.124L9.356 17.328L9.5 18.132L15.668 17.844C15.608 18.516 15.536 19.188 15.428 19.632H8.456V20.4H17.924V19.632H16.34C16.592 18.408 16.712 16.452 16.712 14.976ZM16.928 24.468V23.712H10.556V21.336H9.644V24.468H16.928ZM30.8592 20.4V19.632H26.5632V18.408H29.6472V14.832H22.6032V18.408H25.6512V19.632H21.3912V20.4H30.8592ZM28.7352 17.652H23.5152V15.576H28.7352V17.652ZM22.4112 21.444V22.2H28.7712V24.912H29.6832V21.444H22.4112ZM39.91 18.972V18.24H33.574V17.184H39.73V14.76H32.65V15.492H38.818V16.5H32.662V18.972H35.734V20.076H31.474V20.844H40.942V20.076H36.646V18.972H39.91ZM32.482 21.756V22.512H38.83V24.912H39.754V21.756H32.482ZM52.7251 20.628V15.072H51.8131V17.004H46.4731V15.072H45.5491V20.628H48.6691V22.764H44.4091V23.532H53.8771V22.764H49.5811V20.628H52.7251ZM51.8131 19.872H46.4731V17.76H51.8131V19.872ZM63.0599 24.84V14.352H62.1479V24.84H63.0599ZM59.9759 15.468H54.9839V16.236H59.0039C58.8119 18.6 57.2519 20.88 54.5999 22.044L55.1279 22.764C57.8399 21.48 59.9279 18.876 59.9759 15.468Z",
    fill: "#F6F7F8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewTooltip);
export default __webpack_public_path__ + "static/media/viewTooltip.a10cfcc4a239cd2f2d73a5035749362c.svg";
export { ForwardRef as ReactComponent };